"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpRubricCriteriaStatusBadge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var isNull_1 = __importDefault(require("lodash/isNull"));
var DpRubricCriteriaStatusBadge_styled_1 = require("./DpRubricCriteriaStatusBadge.styled");
var DpRubricCriteriaStatusBadge = function (_a) {
    var value = _a.value, status = _a.status;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return (!(0, isNull_1.default)(value) && ((0, jsx_runtime_1.jsx)(DpRubricCriteriaStatusBadge_styled_1.StyledRubricCriteriaStatusBadge, { "data-testid": "rubric-criteria-status-badge", status: status, children: t("studentsDetails.ratingCriterias.".concat(value)) })));
};
exports.DpRubricCriteriaStatusBadge = DpRubricCriteriaStatusBadge;
exports.default = exports.DpRubricCriteriaStatusBadge;
